let submitBtn = document.getElementById("submit-btn");
let files = document.getElementById("files");
let fileNameList = document.getElementById("fileNames");

let globalFileData;

//! Disable Console.log for production
// console.log = function() {}

// Runs whenever new files are added into input. On confirmation.
files.addEventListener("change", (ev) => {
    let files = ev.currentTarget.files;
    let readers = [];

    // If no files have been input, stop here.
    if (!files.length) return;

    // Disable Send Button
    submitBtn.classList.add("disabled");

    // Empty Preview
    while (fileNameList.firstChild) {
        fileNameList.removeChild(fileNameList.firstChild);
    }

    // Downsize each input file, create (max 5 files)
    let maxUpload;
    if (files.length >= 5) {
        maxUpload = 5;
    } else {
        maxUpload = files.length;
    }

    for (let i = 0; i < maxUpload; i++) {
        readers.push(handleImageUpload2(files[i]));
    }

    Promise.all(readers).then((values) => {
        globalFileData = values;

        // Enable Send button when compression finished.
        submitBtn.classList.remove("disabled");
        console.log("Finished compressing all images");
    });
});

/**
 * This function receives an ID of an Input field, checks if it has a value,
 * returns value if it has one,
 * otherwise mark field with red border (err-input class) and return nothing.
 *
 * @param {String} fieldID Element ID as used in the DOM
 * @returns {String | None}
 */
function getInputOf(fieldID) {
    let field = document.getElementById(fieldID);

    if (field.value === "") {
        // Red border around field
        field.classList.add("err-input");
        // Show Error Message above Send Button
        document.getElementById("err-incomplete").classList.remove("hidden");
        return;
    } else {
        return field.value;
    }
}

function cleanErrors() {
    // Hide Error Messages above Send-Button
    let errs = document.getElementsByClassName("err-msg");
    for (let i = 0; i < errs.length; i++) {
        errs[i].classList.add("hidden");
    }

    // Remove red borders of all Input fields
    let errsInput = document.getElementsByClassName("err-input");
    for (let i = 0; i < errsInput.length; i++) {
        errsInput[i].classList.remove("err-input");
    }
}

async function send() {
    // Clean all Errors, before eventually creating new ones.
    cleanErrors();

    /* ---------------------------------------------------------- */

    let pass = true;

    let name = getInputOf("name");
    if (!name) pass = false;

    let email = getInputOf("email");
    if (!email) pass = false;

    let marke = getInputOf("marke");
    if (!marke) pass = false;

    let modell = getInputOf("modell");
    if (!modell) pass = false;

    let price = getInputOf("price");
    if (!price) pass = false;

    let description = getInputOf("description");
    if (!description) pass = false;

    // If one attribute is missing, don't proceed
    if (!pass) return;

    // Show Error Message if no image is uploaded
    if (!globalFileData) {
        document.getElementById("err-no-img").classList.remove("hidden");
    }

    // Don't send anything without consent
    let consent = document.getElementById("consent").checked;
    if (!consent) {
        document.getElementById("err-consent").classList.remove("hidden");
        return;
    }
    /* ---------------------------------------------------------- */

    let body = {
        name: name,
        email: email,
        marke: marke,
        modell: modell,
        description: description,
        price: price,
        files: globalFileData,
    };

    console.log(body);

    submitBtn.classList.add("disabled")

    let url = "https://europe-west1-der-recyclist.cloudfunctions.net/app/sendMail";
    fetch(url, {
        method: "POST",
        headers: {
            Accept: "application/json, text/plain, */*",
            "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
    }).then((res) => {
        console.log(res);
        console.log(res.status);
        if(res.status == 200) {
            document.getElementById("success").classList.remove("hidden")
        } else {
            document.getElementById("err-not-send").classList.remove("hidden")
        }
    });
}

/* ---------------------------------------------------------------------------------------------- */
/* ---------------------------------------------------------------------------------------------- */
/* ---------------------------------------------------------------------------------------------- */

// Modified Version of: https://donaldcwl.github.io/browser-image-compression/example/basic.html
// TODO: Add some comments...
function handleImageUpload2(img) {
    // Create a "Spinner" replace later by Bootstrap spinner
    const spinner = document.createElement("span");
    spinner.textContent = "Bild lädt...";
    spinner.classList.add("spinner");
    fileNameList.appendChild(spinner);

    return new Promise(async (resolve, reject) => {
        const imageFile = img;
        console.log("originalFile instanceof Blob", imageFile instanceof Blob); // true
        console.log(`originalFile size ${imageFile.size / 1024 / 1024} MB`);

        // TODO: Possible to only say maxSizeMB?
        const options = {
            maxSizeMB: 1,
            maxWidthOrHeight: 1920,
            useWebWorker: true,
        };
        try {
            const compressedFile = await imageCompression(imageFile, options);
            console.log("compressedFile instanceof Blob", compressedFile instanceof Blob); // true
            console.log(`compressedFile size ${compressedFile.size / 1024 / 1024} MB`); // smaller than maxSizeMB
            console.log("-----------------------------------------");

            // Blob -> Base64
            let fr = new FileReader();
            fr.onload = () => {
                resolve(fr.result);
            };

            fr.onerror = () => {
                reject(fr);
            };

            // Append Filename to list
            const fileName = document.createElement("li");
            fileName.textContent = img.name;
            //fileNameList.appendChild(fileName)

            // Remove one Spinner
            const spinner = document.getElementsByClassName("spinner")[0];
            fileNameList.removeChild(spinner);

            // Append Image to List
            const imgElement = document.createElement("img");
            imgElement.classList.add("preview");
            imgElement.src = URL.createObjectURL(compressedFile);
            fileNameList.appendChild(imgElement);

            fr.readAsDataURL(compressedFile);
            //resolve(compressedFile);
            //await send2(compressedFile); // write your own logic
        } catch (error) {
            console.log(error);
            reject(error);
        }
    });
}
